// extracted by mini-css-extract-plugin
export default {"layout":"index_layout_eOvDp","homeFooterWrapper":"index_homeFooterWrapper_jcpjv"};